module.exports = __webpack_public_path__ + "static/media/onepassword.48cfce97.png";